import { paymentApi } from 'services/http';

function getRowVersion(invoice) {
  if (invoice && invoice.rowVersion) {
    return invoice.rowVersion;
  }
  return null;
}

export const requestForHandlePayConfirm = (invoice, paymentObj) => {
  const headers = {
    rowVersion: getRowVersion(invoice)
  };
  return new Promise((resolve, reject) => {
    paymentApi
      .post(`invoices/${invoice.id}/paid`, { ...paymentObj, withoutRedux: true }, { headers })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateStateByObj = (parentObj, inputObjData) => {
  if (inputObjData && typeof inputObjData === 'object') {
    const keys = Object.keys(inputObjData);
    if (keys && keys.length > 0) {
      const newState = Object.assign({}, parentObj);
      keys.forEach(keyName => {
        if (typeof inputObjData[keyName] === 'object') {
          newState[keyName] = Object.assign({}, newState[keyName], inputObjData[keyName]);
        } else {
          newState[keyName] = inputObjData[keyName];
        }
      });
      return newState;
    }
  }
  return parentObj;
};
